export const GoogleIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill="#4285f4"
        d="M8.143 6.727v2.71h3.844a3.23 3.23 0 0 1-1.435 2.107l2.318 1.763C14.22 12.085 15 10.29 15 8.158q-.002-.744-.13-1.431z"
      />
      <path
        fill="#34a853"
        d="m4.14 9.332-.524.392-1.85 1.413A7.16 7.16 0 0 0 8.142 15c1.929 0 3.546-.624 4.727-1.693l-2.318-1.763c-.636.42-1.448.675-2.409.675-1.857 0-3.435-1.228-4-2.883z"
      />
      <path
        fill="#fbbc05"
        d="M1.766 4.863a6.8 6.8 0 0 0 0 6.275c0 .006 2.377-1.808 2.377-1.808A4.1 4.1 0 0 1 3.916 8c0-.464.084-.91.227-1.33z"
      />
      <path
        fill="#ea4335"
        d="M8.142 3.787c1.052 0 1.987.357 2.734 1.044l2.046-2.005C11.682 1.694 10.07 1 8.142 1a7.15 7.15 0 0 0-6.376 3.863L4.142 6.67c.565-1.655 2.143-2.883 4-2.883"
      />
    </svg>
  );
};
